"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSlots = exports.default = exports.Template = exports.Slot = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const defaultContextValue = {};
const SlotContext = /*#__PURE__*/(0, _react.createContext)(defaultContextValue);
const Template = function (_) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
exports.Template = Template;
const Slot = function (props) {
  var _scopeMap$get;
  const {
    children,
    name = "default"
  } = props;
  const {
    slotMap,
    scopeMap,
    id
  } = (0, _react.useContext)(SlotContext);
  const slotContent = (scopeMap === null || scopeMap === void 0 ? void 0 : (_scopeMap$get = scopeMap.get(id)) === null || _scopeMap$get === void 0 ? void 0 : _scopeMap$get.get(name)) || (slotMap === null || slotMap === void 0 ? void 0 : slotMap.get(name));
  const [replaced, replacedProps] = slotContent || [];
  const replacedContent = replaced || children;
  if (typeof replacedContent === "function") {
    return replacedContent((props === null || props === void 0 ? void 0 : props.props) || replacedProps);
  }
  return replacedContent;
};
exports.Slot = Slot;
const withSlots = function (Component) {
  const ComponentWithSlots = function (props) {
    const {
      scopeMap: parentalScopeMap
    } = (0, _react.useContext)(SlotContext);
    const {
      children
    } = props;
    const childrenArray = typeof children === "undefined" ? [] : Array.isArray(children) ? children : [children];
    const templateCollection = childrenArray.filter(function (child) {
      return (child === null || child === void 0 ? void 0 : child.type) === Template;
    });
    const scopedCollection = templateCollection.filter(function (c) {
      return typeof c.props.scope !== "undefined";
    });
    const scopeMap = parentalScopeMap || new WeakMap();
    scopedCollection.forEach(function (_ref) {
      let {
        props
      } = _ref;
      if (!scopeMap.has(props.scope)) {
        scopeMap.set(props.scope, new Map());
      }
      scopeMap.get(props.scope).set(props.slot || "default", [props.children, props.props]);
    });
    const slotMap = new Map(templateCollection.map(function (_ref2) {
      let {
        props
      } = _ref2;
      return [props.slot || "default", [props.children, props.props]];
    }));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(SlotContext.Provider, {
      value: {
        id: ComponentWithSlots,
        scopeMap,
        slotMap
      },
      "data-testid": "ComponentWithSlots",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
        ...props
      })
    });
  };
  return ComponentWithSlots;
};
exports.withSlots = withSlots;
var _default = exports.default = withSlots;